import React from 'react';
import { motion } from 'framer-motion';
import './ScheduleSection.css';

const ScheduleSection = () => {
  const scheduleData = [
    {
      time: '8:00',
      event: 'افتتاحية اليوم',
      eventEn: 'Opening of the Day'
    },
    {
      time: '9:00',
      event: 'بداية العمل',
      eventEn: 'Start of Work'
    },
    {
      time: '10:00 - 10:30',
      event: 'الورشة الاولى- prompt engineering',
      eventEn: 'First Workshop - Prompt Engineering'
    },
    {
      time: '12:00 - 12:30',
      event: 'الورشة الثانية - بناء خطة عمل',
      eventEn: 'Second Workshop - Building a Work Plan'
    },
    {
      time: '14:15 - 15:00',
      event: 'استراحة غداء',
      eventEn: 'Lunch Break'
    },
    {
      time: '15:00 - 15:30',
      event: 'الورشة الثالثة - خطاب المصعد',
      eventEn: 'Third Workshop - Elevator Pitch'
    },
    {
      time: '18:15',
      event: 'تسليم مشروع العرض النهائي',
      eventEn: 'Submission of the Final Presentation Project'
    },
    {
      time: '18:30 - 19:15',
      event: 'مرحلة التحكيم الاولى',
      eventEn: 'First Judging Phase'
    },
    {
      time: '19:30 - 20:00',
      event: 'مرحلة التحكيم النهائية',
      eventEn: 'Final Judging Phase'
    },
    {
      time: '20:00 - 20:30',
      event: 'اعلان الفائزين واختتام اليوم',
      eventEn: 'Announcement of Winners and Closing of the Day'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="schedule-section">
      <div className="schedule-background">
        <div className="wave-dots-container">
          <img src="/wave-dots.svg" alt="Futuristic wave dots" className="wave-dots-svg" />
        </div>
        <div className="gradient-circle"></div>
      </div>
      
      <div className="container">
        <motion.div 
          className="schedule-content"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.h2 className="schedule-title" variants={itemVariants}>
            جدول اليوم
          </motion.h2>
          
          <motion.div className="schedule-subtitle" variants={itemVariants}>
            <span className="schedule-date">11 أكتوبر 2025</span>
            <span className="schedule-emoji">📅</span>
          </motion.div>

          <motion.div className="schedule-timeline" variants={itemVariants}>
            {scheduleData.map((item, index) => (
              <motion.div 
                key={index}
                className="schedule-item"
                variants={itemVariants}
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.2 }}
              >
                <div className="schedule-time">
                  <div className="time-badge">
                    {item.time}
                  </div>
                </div>
                
                <div className="schedule-divider">
                  <div className="divider-line"></div>
                  <div className="divider-dot"></div>
                </div>
                
                <div className="schedule-event">
                  <h3 className="event-title-ar">{item.event}</h3>
                  <p className="event-title-en">{item.eventEn}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>

        </motion.div>
      </div>
    </section>
  );
};

export default ScheduleSection;
